import React, { useState } from "react";
import styled from "styled-components";
import Button from "ui/Button";
import Overlay from "ui/Overlay";

interface VideoButtonProps {
  src?: string;
}

const VideoButton = ({ src }: VideoButtonProps) => {
  const [videoVisible, setVideoVisible] = useState(false);

  const showVideo = () => setVideoVisible(true);
  const closeVideo = () => setVideoVisible(false);
  return (
    <>
      <StyledButton color="success" onClick={showVideo}>
        VER VÍDEO
      </StyledButton>
      <Overlay visible={videoVisible} onClose={closeVideo}>
        <iframe
          title="iparque-video"
          src={src}
          width="100%"
          height="100%"
          allow="autoplay;fullscreen"
          frameBorder={0}
        />
      </Overlay>
    </>
  );
};

export default VideoButton;

const StyledButton = styled(Button)`
  padding: 0 35px;
`;
